<script>
import { APP_CHANNEL, NUOYA_APPID, isBxzDomain } from '@/common/utils/variables';
import { isToB, isBxs } from 'base/config'
export default {
  name: 'NameCard',
  props: {
    nameCardInfor: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    isMember() {
      const { nameCardInfor } = this
      return nameCardInfor.memberLevelName || nameCardInfor.offlineBroker
    },
    isMedalShow() {
      const { nameCardInfor } = this
      return nameCardInfor.memberLevelMedal && !nameCardInfor.offlineBroker
    },
    isBxzDomain() {
      return isBxzDomain
    }
  },
  created() {
    this.isCircle = (APP_CHANNEL === 'NUOYA') || !isToB
    this.isBxs = isBxs
  },
  methods: {
    resizePicture(url, size) {
      if (isNaN(size) || !url) {
        return url
      }
      if (APP_CHANNEL === 'NUOYA' || this.nameCardInfor.tobAppId == NUOYA_APPID) {
        return url
      }
      return `${url}?x-oss-process=image/resize,m_mfit,h_${size},w_${size}`
    },
  },
}
</script>
<template>
  <a
    class="name-card"
    href="javascript:;"
    data-stat-id="name"
    :data-stat-ep="
      JSON.stringify({
        productId: nameCardInfor.insuranceTypeId,
      })
    "
    @click="$emit('click')"
  >
    <div class="head" :class="{ circle: isCircle }">
      <img
        :src="resizePicture(nameCardInfor.photo, 80)"
        :alt="nameCardInfor.name"
      >
    </div>
    <div class="info" :class="{ member: nameCardInfor.position }">
      <p class="name">
        <span>{{ nameCardInfor.name }}</span>
        <!-- <i v-if="isMedalShow" class="icon-member">
          <img
            :src="nameCardInfor.memberLevelMedal"
            :alt="nameCardInfor.memberLevelName"
          />
        </i> -->
      </p>
      <p v-if="nameCardInfor.position && isBxzDomain" class="position">
        {{ nameCardInfor.position }}
      </p>
      <!-- <p v-if="nameCardInfor.offlineBroker">{{ isBxs ? '保险师' : '' }}专员</p>
      <p v-else-if="nameCardInfor.memberLevelName">
        {{ nameCardInfor.memberLevelName }}
      </p> -->
    </div>
  </a>
</template>
<style lang="postcss" scoped>
@import 'variable.css';
.name-card {
  display: block;
  position: relative;
  height: 0.72rem;
  color: #333;
  overflow: hidden;
  .info {
    font-size: 0.3rem;
    text-align: left;
    p {
      font-size: 0.32rem;
      font-weight: 400;
      @apply --text-ellipsis;
    }
  }
  .head {
    overflow: hidden;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translate(0, -50%);
    &.circle {
      border-radius: 100%;
      > img {
        border-radius: 100%;
      }
    }
    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .member {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    width: 100%;
    line-height: 1.2;
    > p {
      @apply --text-ellipsis;
    }
    .name {
      padding-right: 0.42rem;
      span {
        display: inline-block;
        max-width: 100%;
        @apply --text-ellipsis;
        vertical-align: middle;
      }
    }
    .position {
      margin-top: 0.06rem;
      font-size: 0.24rem;
      color: #999;
      transform: scale(0.83);
      transform-origin: left top;
    }
  }
}
.icon-member {
  z-index: 1;
  position: absolute;
  display: inline-block;
  overflow: hidden;
  width: 0.3rem;
  height: 0.3rem;
  margin-left: 0.06rem;
  img {
    width: 100%;
  }
}
@media screen and (device-width <= 320px) {
  .card-function-bar {
    .card-telephone,
    .card-view {
      span {
        font-size: 12px;
      }
    }
  }
  .name-card {
    .head {
      left: 4%;
    }
    .info {
      p {
        font-size: 13px;
      }
    }
  }
  .icon-member {
    margin-left: 0;
  }
}
</style>
<style lang="postcss">
.name-card {
  .info {
    padding-left: 0.94rem;
  }
  .head {
    width: 0.8rem;
    height: 0.8rem;
  }
}
</style>
